import React, { useEffect, useRef, useState } from "react";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { useReactToPrint } from "react-to-print";
import BasePaymentStatus from "./BasePaymentStatus";

export default function PaymentStatus() {
    const url = config.url.CONTEXT_READ_URL + "payment-invoice-details?tpslTxnId=";
   

    return (
        <React.Fragment>
            <BasePaymentStatus apiUrl={url} showNote={true} successNavigatePath="/PrintApplication"
                failureNavigatePath="/ProfileDetailsWay" 
                noteNavigatePath="/FileUploads"  />
           
        </React.Fragment>
    )
}